import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Popconfirm, Tooltip, message, Modal } from 'antd';
import $ from '../../../common/AjaxRequest';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import moment from 'moment';
import { saveParams } from '../../../actions/noticeActions';
import MorePmHandover from './MorePmHandover';

const setProject = (setSession, item, isCenter) => {
    setSession.invId = item.investigationId;
    setSession.invName = item.investigationName;
    setSession.investigationSiteCode = "";
    setSession.investigationSiteName = isCenter ? "中心汇总" : '';
    setSession.siteId = '';
};

class PmHandover extends Component {
    state = {
        loading: false,
        pagination: {
            pageSize: 10,
            current: 1,
        },
        data: [],
        loading: false,
    }

    componentDidMount() {
        this.loadData()
    }

    loadData = () => {
        const { pagination } = this.state;
        const { pageSize, current } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.home.queryCurrentPmStaffHandover,
            data: {
                limit: pageSize,
                offset: current,
            },
            dataType: 'json',
            doneResult: res => {
                const { list = [], totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    pagination,
                    data: list,
                    loading: false,
                });
            }
        };
        $.sendRequest(options);
    }

    setSession = (setSession) => {
        if (Object.keys(setSession).length !== 0) {
            for (let [k, v] of Object.entries(setSession)) {
                sessionStorage[k] = v;
            }
        }
    }

    //标记已处理
    handleComplate = (markType, userScheduleId) => {
        const options = {
            method: 'POST',
            url: API_URL.notice.markScheduleDeal,
            data: {
                markType,
                userScheduleId,
            },
            dataType: 'json',
            doneResult: res => {
                if (res && res.success) {
                    message.success(res.success);
                    this.loadData();
                    window.dispatchEvent(new CustomEvent('smo:notice-count-refresh'));
                } else {
                    message.error((res && res.error) || '标记失败');
                }
            },
        };
        $.sendRequest(options);
    }

    //点击消息回调
    clickNotice = (text , record , index) => {
        const {
            handoverNum, 
            whetherConfirm,
            investigationId = '',
            investigationName = '',
            investigationSiteId = '', 
            investigationSiteName = '',
            investigationSiteCode = '',
        } = record;
        if (whetherConfirm) {
            const { saveParams } = this.props;
            saveParams({ handoverNum });
            location.href = `/#/user/pmTransfer`;
        } else {
            let params = {
                handoverNum,
                investigationId, 
                investigationName, 
                investigationSiteId, 
                investigationSiteName, 
                investigationSiteCode,
                type: 'PM',
            };
            let setSession = {};
            setProject(setSession, params, true);
            setSession.curRole = 'PM';
    
            // 保存页面查询参数至store
            const { saveParams } = this.props;
            if (Object.keys(params).length !== 0) {
                saveParams({...params});
            }
            
            this.setSession(setSession);
            location.href = `/#/execute/transfer`;
        }
    }

    showMoreInfo = () => {
        const { data } = this.state;
        this.moreCrcHandoverRef.show(data);
    }

    render() {
        const { data, loading } = this.state;
        const content = data.slice(0,8).map((el, index) => {
            return (
                <div className='backlogli'>
                    <Tooltip title={el.remark} overlayStyle={{ maxWidth: 350 }}>
                        <div 
                            className='left' 
                            style={{color: el.red ? 'red' : '#5750b7'}} 
                            onClick={() => this.clickNotice(null, el, index)}
                        >
                            {`${el.remark}`}
                        </div>    
                    </Tooltip>
                    <div className='right'>
                        <br />
                        <span style={{color:'#cccccc'}}>{moment(el.createTime).format('YYYY-MM-DD')}</span>
                    </div>
                </div>
            )
        })
        return (
            <div className="flexItem outer">
                <div className="modTitle">进行中的PM交接记录</div>
                <div>
                    {content}
                    <div className='data_null'>
                        {
                            data.length == 0 && <span><i className='anticon anticon-frown-o'></i>暂无数据</span>
                        }
                    </div>
                    {
                        data.length != 0 && <div className='more_btn'>
                            <a onClick={this.showMoreInfo}>{`查看更多>>`}</a>
                        </div>
                    }
                </div>
                <MorePmHandover 
                    ref={el => this.moreCrcHandoverRef = el}
                    clickNotice={this.clickNotice}
                />
            </div>
        );
    }
}

const mapSateToProps = (state) => ({
    params: state.noticeState.params || {},
});

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
}

export default connect(mapSateToProps, mapDispatchToProps)(PmHandover);



// WEBPACK FOOTER //
// ./src/components/homePage/afficheNews/PmHandover.js